import React, {
  createContext,
  useContext,
  useState,
  useRef,
  useMemo,
  useEffect,
} from "react";
import { OrderAddRepository } from "../../repository/AdminDashboard/Order_repository";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
const StateContext = createContext();
const initialState = {
  order: {
    orderNumber: "",
    factorNumber: "",
    timeorder: "",
    status: "",
    receiver: "",
    phoneNumber: "",
    postalcode: "",
    city: "",
    address: "",
    table: [],
    totalCost: "",
    howSend: "",
    codeSend: "",
  },
  orderTable: [],
};
const OrderAddContext = ({ children }) => {
  const selectRef = useRef(null);
  const [orderTable, setorderTable] = useState(initialState.orderTable);
  const [Loading, setLoading] = useState(false);
  const [timer, settimer] = useState(null);
  const [searchtext, setsearchtext] = useState("");
  const [productopt, setproductopt] = useState([]);
  const [itswanted, setitswanted] = useState("");
  const [amounts, setamounts] = useState([]);
  const [amount, setamount] = useState("");
  const [name, setname] = useState("");
  const [jsonArray, setJsonArray] = useState([]);
  const [value, setValue] = useState(1);
  const [response, setresponse] = useState("");
  const [time, settime] = useState(initialState.order.timeorder);
  const [factorNumber, setfactorNumber] = useState(
    initialState.order.factorNumber
  );
  const [status, setstatus] = useState(initialState.order.status);
  const [orderNumber, setorderNumber] = useState(
    initialState.order.orderNumber
  );
  const [receiver, setreceiver] = useState(initialState.order.receiver);
  const [phone, setphone] = useState(initialState.order.phoneNumber);
  const [postalcode, setpostalcode] = useState(initialState.order.postalcode);
  const [city, setcity] = useState(initialState.order.city);
  const [address, setaddress] = useState(initialState.order.address);
  const [howSend, sethowSend] = useState(initialState.order.howSend);

  const [codeSend, setcodeSend] = useState(initialState.order.codeSend);

  function isNumeric(str) {
    return /^(\+)?\d+$/.test(str.trim());
  }

  // send order
  const navigate = useNavigate();

  const getOrderAdd = async (order) => {
    const order_add = await OrderAddRepository.addorder(order);
    setresponse(order_add.status);
    setLoading(true);
    // console.log(order_add.code)
    if (order_add.code == 1) {
      navigate("/order");
      initialState.order.orderNumber = "";
      initialState.order.factorNumber = "";
      initialState.order.timeorder = "";
      initialState.order.status = "";
      initialState.order.receiver = "";
      initialState.order.phoneNumber = "";
      initialState.order.city = "";
      initialState.order.address = "";
      initialState.order.table = [];
      initialState.order.totalCost = "";
      initialState.order.howSend = "";
      initialState.order.codeSend = "";
      setTimeout(() => {
        toast.success(order_add.status, {
          className: "text-12 text-dark-blue-200",
        });
      }, 1000);
    } else if (order_add.code == 0) {
      // console.log("hkk");
      toast.error(order_add.status, {
        className: "text-12 text-dark-blue-200",
      });
    }
  };

  // get product option
  const getproduct = async (text) => {
    const product = await OrderAddRepository.product(text);
    setamounts(product.amount);
    setproductopt(product.products);
  };

  // accept done
  const doneAdd = async () => {
    if (initialState.order.orderNumber.length == 0) {
      return toast.error("شماره سفارش را وارد کنید", {
        className: "text-12 text-dark-blue-200",
      });
    }
    if (initialState.order.factorNumber.length == 0) {
      return toast.error("شماره فاکتور را وارد کنید", {
        className: "text-12 text-dark-blue-200",
      });
    }
    if (initialState.order.timeorder.length == 0) {
      return toast.error("تاریخ سفارش  را وارد کنید", {
        className: "text-12 text-dark-blue-200",
      });
    }
    if (initialState.order.status == 0) {
      return toast.error("وضعیت سفارش  را وارد کنید", {
        className: "text-12 text-dark-blue-200",
      });
    }
    if (initialState.order.receiver.length == 0) {
      return toast.error("نام تحویل گیرنده را وارد کنید", {
        className: "text-12 text-dark-blue-200",
      });
    }
    if (initialState.order.phoneNumber.length == 0) {
      return toast.error("شماره تلفن همراه را وارد کنید", {
        className: "text-12 text-dark-blue-200",
      });
    }
    if (isNumeric(initialState.order.phoneNumber) === false) {
      return toast.error("شماره خود را صحیح وارد کنید", {
        className: "text-12 text-dark-blue-200",
      });
    }
    if (initialState.order.city.length == 0) {
      return toast.error("شهر را وارد کنید", {
        className: "text-12 text-dark-blue-200",
      });
    }
    if (initialState.order.address.length == 0) {
      return toast.error("آدرس را وارد کنید", {
        className: "text-12 text-dark-blue-200",
      });
    }
    if (initialState.order.table.length == 0) {
      return toast.error("محصولی ثبت نشده است", {
        className: "text-12 text-dark-blue-200",
      });
    }
    if (initialState.order.howSend.length == 0) {
      return toast.error("نحوه ارسال را مشخص کنید", {
        className: "text-12 text-dark-blue-200",
      });
    }
    // console.log(initialState.order.address)
    await getOrderAdd(initialState.order);
  };

  // onchange product
  function onchange({ props, state, methods }) {
    if (timer != null) {
      clearTimeout(timer);
      settimer(null);
    }
    if (state.search != searchtext && state.search.length > 2) {
      settimer(
        setTimeout(() => {
          // console.log({ props, state, methods });
          setsearchtext(state.search);
          setLoading(true);
          getproduct(state.search).then(() => {
            setLoading(false);
            clearInterval(timer);
          });
          // console.log(Loading);
        }, 1000)
      );
    }
    return methods.sortBy().filter((item) => item);
  }

  // onchange select option
  const onchangeopt = (event) => {
    // console.log(event[0].value);
    if (event.length > 0) {
      // setitswanted(event[0].value)
      const result = amounts.find((obj) => obj.name === event[0].value);
      // console.log(result.amount);
      setamount(result.amount);
      setname(result.name);
    }
  };

  const buttonSearch = (event) => {
    if (name.length > 0 && amount.length > 0) {
      const json = {
        id: jsonArray.length + 1,
        productName: name,
        number: 1,
        amount: amount,
        cost: amount,
      };
      setJsonArray([...jsonArray, json]);
    }
    event.preventDefault();
    setamount("");
    setname("");
    selectRef.current.clearAll();
    if (selectRef.current) {
      selectRef.current.clearAll();
    }
  };

  // update json
  const incrementNumber = (id) => {
    const updatedProducts = jsonArray.map((jsonArray) => {
      if (jsonArray.id == id) {
        const updatedNumber = jsonArray.number + 1;
        const updatedCost = updatedNumber * parseInt(jsonArray.amount);
        return {
          ...jsonArray,
          number: updatedNumber,
          cost: updatedCost.toString(),
        };
      } else {
        return jsonArray;
      }
    });
    setJsonArray(updatedProducts);
  };

  // decrecw
  const decrementNumber = (id) => {
    const updatedProducts = jsonArray.map((jsonArray) => {
      if (jsonArray.id == id) {
        const updatedNumber = Math.max(jsonArray.number - 1, 1);
        const updatedCost = updatedNumber * parseInt(jsonArray.amount);
        return {
          ...jsonArray,
          number: updatedNumber,
          cost: updatedCost.toString(),
        };
      } else {
        return jsonArray;
      }
    });
    setJsonArray(updatedProducts);
  };

  //  onchange inpu type number
  function handleIncrease(event) {
    event.preventDefault();

    const id = event.target.id;
    incrementNumber(id);
    // (jsonArray[id-1].number)
    // const itemWithId2 = jsArray.find(item => item.id == id);
    // itemWithId2.number = itemWithId2.number + 1
    // itemWithId2.cost = itemWithId2.number * itemWithId2.amount
    // const updatedJsonArray = JSON.stringify(jsArray);
    // setJsonArray(updatedJsonArray);

    // const updatedJsonArray = JSON.stringify(jsArray);
    // setJsonArray(updatedJsonArray)

    // if(itemToUpdate){
    //   // itemToUpdate.number = value  + 1
    //   // itemToUpdate.cost = jsArray[id-1].number * jsArray[id-1].amount
    // // console.log( itemToUpdate)
    // }else{
    //   setValue(1)
    // }
    // console.log( jsArray)
    // setJsonArray(jsArray)
    // const updatedJsonArray = JSON.stringify(jsArray);
    // setJsonArray(updatedJsonArray)
  }
  function handleDecrease(event) {
    event.preventDefault();
    const id = event.target.id;
    decrementNumber(id);
    // if (value > 1) {
    //   setValue(value - 1);
    //   // setid(event.target.id)

    // }
  }

  // total cost
  const totalCost = useMemo(() => {
    let sum = 0;

    jsonArray.forEach((row) => {
      const num = parseInt(row.cost, 10);

      sum += num;
    });

    return sum;
  }, [jsonArray]);

  const onchangeInput = (event) => {
    const { id, value } = event.target;

    switch (id) {
      case "ordernumber":
        setorderNumber(value);
        break;
      case "receiver":
        setreceiver(value);
        break;
      case "phone":
        setphone(value);
        break;
      case "postalcode":
        setpostalcode(value);
        break;
      case "city":
        setcity(value);
        break;
      case "address":
        setaddress(value);
        break;
      case "factorNumber":
        setfactorNumber(value);
        break;
      case "codeSend":
        setcodeSend(value);
        break;
      default:
        break;
    }
  };

  const changedate = (event) => {
    settime(event.format());
  };
  const changestatus = (event) => {
    if (event.length > 0) {
      setstatus(event[0].value);
    }
  };
  const onchangeSend = (event) => {
    if (event.length > 0) {
      sethowSend(event[0].value);
    }
  };

  initialState.order.orderNumber = orderNumber.trim();
  initialState.order.factorNumber = factorNumber.trim();
  initialState.order.timeorder = time.trim();
  initialState.order.status = status.trim();
  initialState.order.receiver = receiver.trim();
  initialState.order.phoneNumber = phone.trim();
  initialState.order.city = city.trim();
  initialState.order.address = address.trim();
  initialState.order.table = jsonArray;
  initialState.order.totalCost = totalCost;
  initialState.order.howSend = howSend.trim();
  initialState.order.codeSend = codeSend.trim();

  return (
    <StateContext.Provider
      value={{
        changedate,
        orderTable,
        onchange,
        Loading,
        onchangeopt,
        productopt,
        buttonSearch,
        selectRef,
        jsonArray,
        value,
        onchangeInput,
        handleIncrease,
        handleDecrease,
        totalCost,
        doneAdd,
        changestatus,
        onchangeSend,
      }}>
      {children}
    </StateContext.Provider>
  );
};
function OrderAddUseContext() {
  return React.useContext(StateContext);
}
export default OrderAddContext;
export { OrderAddUseContext };
